import React from 'react';
import { useMetadataContext } from '../../utils/contexts/MetadataContext';

const EnvironmentRibbon: React.FC = () => {
    const { deployment } = useMetadataContext();

    // Don't render anything if:
    // 1. No deployment context
    // 2. Is production environment
    // 3. No display label (fallback safety check)
    if (!deployment || deployment.is_production) {
        return null;
    }

    return (
        <div
            className="fixed bottom-18 -left-6 z-50 px- py-2 bg-blue-500 text-white
                        font-bold text-xs tracking-wide opacity-80 rotate-45 origin-bottom-left
                        min-w-34 text-center shadow-md rounded-tr pointer-events-none select-none
                        transition-opacity duration-300"
        >
            {deployment.display_label?.toUpperCase()}
        </div>
    );
};

export default EnvironmentRibbon;
